import { useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useLenis } from 'lenis/react'
import { forEach } from 'lodash'

import { useMotionTouchMedia } from '@/hooks/use-motion-touch-media'
import { useLoaderStore } from '@/store/loader'

import { createScrubWordsMotion, getScrollTriggerOptions } from './shared'

export const useParagraphMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const revealScrollTrigger = useRef<ScrollTrigger>(null!)
  const fontsReady = useLoaderStore((state) => state.fontsReady)
  const lenis = useLenis()

  /**
   * reveal setup
   */
  useMotionTouchMedia(
    {
      pointer({ selector }) {
        if (!fontsReady || !lenis) return

        const paragraphs = selector?.('[data-motion-paragraph]')

        if (ScrollTrigger.isInViewport(paragraphs[0]?.parentNode)) return

        const animation = gsap.timeline()

        forEach(paragraphs, (paragraph, index) => {
          const motion = createScrubWordsMotion(paragraph)
          motion && animation.add(motion.timeline, parseInt(index) * 0.2)
        })

        revealScrollTrigger.current = ScrollTrigger.create({
          ...getScrollTriggerOptions({
            trigger: paragraphs[0]?.parentNode,
            start: 'top 90%',
            end: 'bottom center',
            markers: false,
            scrub: true,
            once: false,
            animation
          })
        })
      }
    },
    { scope: motionRef, dependencies: [fontsReady, lenis] }
  )

  return { motionRef }
}
